import gql from 'graphql-tag'

export const GET_FLOORS_PAGINATION_QUERY = gql`
  query GetFloorsPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getFloors(
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
          id
          title
          order
      }
    }
  }
`
